import type { ComponentProps } from 'react'
import { Badge } from '@/shared/ui/badge'

type BadgeVariant = ComponentProps<typeof Badge>['variant']

/** Maps known status strings to shadcn Badge variants */
const STATUS_VARIANT_MAP: Record<string, BadgeVariant> = {
  published: 'default',
  active: 'default',
  draft: 'secondary',
  inactive: 'secondary',
  pending: 'secondary',
  archived: 'outline',
  deleted: 'destructive',
  error: 'destructive',
}

interface StatusBadgeProps {
  status: string
  label?: string
}

export function StatusBadge({ status, label }: StatusBadgeProps) {
  const variant = STATUS_VARIANT_MAP[status.toLowerCase()] ?? 'outline'
  return <Badge variant={variant}>{label ?? status}</Badge>
}
